<template lang="pug">
.Register
  .text-center.mb-5
    h2.fw-bold.mb-2 {{ $t("message.register") }}
    p.text-muted(v-if="step === 1") {{ $t("message.checkInvitationSubtitle") }}
    p.text-muted(v-else) {{ $t("message.invitationFound") }}
    
  form#register-form(@submit.prevent="step === 1 ? checkInvitation() : register()")
    // Step 1: Email Verification
    transition(name="fade" mode="out-in")
      div(v-if="step === 1" key="step1")
        .form-floating.mb-3
          input.form-control.rounded-3#EmailInputCheck(placeholder='Email' v-model="email" type="email" :disabled="loading")
          label(for="EmailInputCheck") {{ $t("message.email") }}
        
        p.text-danger.text-center.small.mb-3(v-if="error") {{ error }}
        
        .d-grid.gap-2
          button.btn.btn-primary.btn-lg.rounded-3(type="button" @click="checkInvitation" :disabled="loading || !email")
            span.material-icons.me-2(v-if="!loading") search
            span.spinner-border.spinner-border-sm.me-2(v-else)
            | {{ loading ? $t("message.checking") : $t("message.checkInvitation") }}

      // Step 2: Rest of the fields
      div(v-else key="step2")
        .row.g-3.mb-3
          .col-6.form-floating           
            input.form-control.rounded-3#name(placeholder='Name' v-model="firstName")
            label(for="name") {{ $t("message.name") }}
          .col-6.form-floating   
            input.form-control.rounded-3#lastName(placeholder='Last Name' v-model="lastName")
            label(for="lastName") {{ $t("message.lastName") }}
        
        .form-floating.mb-3
          input.form-control.rounded-3#EmailDisplay(v-model="email" type="email" disabled)
          label(for="EmailDisplay") {{ $t("message.email") }}
        
        .row.g-3.mb-3
          .col-6.form-floating
            input.form-control.rounded-3#PasswordInputRegister(placeholder='Password' v-model="password" type="password")
            label(for="PasswordInputRegister") {{ $t("message.password") }}
          .col-6.form-floating
            input.form-control.rounded-3#Password2Input(placeholder='Password2' v-model="password2" type="password")
            label(for="Password2Input") {{ $t("message.rpassword") }}
        
        .form-floating.mb-4
          textarea.form-control.rounded-3#DescriptionInput(placeholder="Describe yourself" v-model="description" style="height: 120px")
          label(for="DescriptionInput") {{ $t("message.describeYourself") }}
        
        .d-grid.gap-2
          button.btn.btn-primary.btn-lg.rounded-3(type="submit" :disabled="loading")
            span.material-icons.me-2 person_add
            | {{ $t("message.register") }}
          button.btn.btn-link.btn-sm.text-decoration-none(type="button" @click="step = 1") {{ $t("message.useDifferentEmail") }}
</template>

<script>
import API from "./../API.js";

export default {
  data(){
    return {
      step: 1,
      loading: false,
      error: "",
      email: "",
      password: '',
      password2: '',
      firstName: "",
      lastName: "",
      description: ""
    }
  },
  methods:{
    checkInvitation() {
      if (!this.email) return;
      this.loading = true;
      this.error = "";
      
      API.getInvitation(this.email.toLowerCase().trim())
        .then(data => {
          if (data && data.status === 'ok') {
            this.step = 2;
            if (data.invitation && data.invitation.name) {
              const names = data.invitation.name.split(' ');
              this.firstName = names[0] || "";
              this.lastName = names.slice(1).join(' ') || "";
            }
          } else {
            this.error = this.$t("message.noInvitationFound");
          }
        })
        .catch(err => {
          console.error(err);
          this.error = this.$t("message.errorCheckingInvitation");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    register(){
      if(!this.email || !this.password || !this.firstName || !this.lastName) {
        alert(this.$t("message.fillAllFields"));
        return;
      }
      if(this.password != this.password2) {
        alert(this.$t("message.rpassword")); // existing key for "Passwords do not match" check in i18n
        return;
      }
      
      this.loading = true;
      API.signup(this.email.toLowerCase().trim(), this.password, this.email.toLowerCase().trim(), {
            firstName: this.firstName,
            lastName: this.lastName,
            description: this.description
          })
      .then(data => {
        if(data && data.status && data.status === 'ok') {
          this.$emit('registered');
          this.$router.push('Feed');
          return;
        }
        alert(data.status || this.$t("message.error")) // should add error key if not exists
      }).catch(err => {
        console.error(err);
        alert("An error occurred")
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped lang="scss">
.form-control {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  padding: 0.75rem 1rem;
  
  &:focus {
    background-color: #fff;
    border-color: #0d6efd;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.1);
  }
  
  &:disabled {
    background-color: #e9ecef;
    opacity: 1;
  }
}

.form-floating > label {
  padding-left: 1rem;
}

.rounded-3 {
  border-radius: 0.75rem !important;
}

.material-icons {
  vertical-align: middle;
  font-size: 1.25rem;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateX(20px);
}
</style>

<style lang="sass">

</style>